import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { Gegevens as Klantgegevens } from '../../../../aansluiting/klant/components/Gegevens'
import { useKlantgegevens } from '../../../../aansluiting/klant/hooks/useKlantgegevens'
import { StyledError } from '../../../../theme/components/StyledError'
import { useCompleteActiviteitForEntity } from '../../hooks/useCompleteActiviteitForEntity'
import type { Activiteit } from '../../types/Activiteit'

interface Props {
  activiteit: Activiteit
  onClose: () => void
}

export const FinishActiviteitDialog = ({ activiteit, onClose }: Props) => {
  const { _id, type, entity } = activiteit
  const [comment, setComment] = useState('')
  const { mutate: completeActiviteitForEntity, error } =
    useCompleteActiviteitForEntity()

  const { data: gegevens } = useKlantgegevens({ id: entity.id })

  const handleClickJa = () => {
    completeActiviteitForEntity(
      {
        entity,
        activiteitInfo: {
          _id,
          text: comment,
        },
      },
      { onSuccess: () => onClose() },
    )
  }

  return (
    <>
      <DialogTitle>{`Afhandelen ${type}`}</DialogTitle>
      <DialogContent>
        <StyledError error={error} />
        <Typography>{`Wilt u deze ${type} afronden? `}</Typography>
        {type === 'KCM1' && <Klantgegevens gegevens={gegevens} />}
        <TextField
          id="standard-textarea"
          label="Eventuele extra opmerking"
          fullWidth
          placeholder="Opmerking"
          value={comment}
          onChange={(event) => setComment(event.target.value)}
          sx={{ mt: 1 }}
          rows={5}
          multiline
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button onClick={handleClickJa} color="primary">
          Ja
        </Button>
      </DialogActions>
    </>
  )
}
